"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var items = [{
  key: '0',
  danger: true,
  label: '危险'
}, {
  key: '1',
  danger: true,
  label: '危险选中'
}, {
  key: '2',
  danger: true,
  disabled: true,
  label: '危险禁用'
}];
var Demo = function Demo() {
  var onClick = function onClick(e) {
    console.log('click ', e);
  };
  return /*#__PURE__*/_react.default.createElement(_antd.Menu, {
    onClick: onClick,
    style: {
      width: 256
    },
    defaultSelectedKeys: ['1'],
    items: items
  });
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorError', 'colorErrorHover', 'colorErrorOutline'],
  key: 'danger'
};
var _default = exports.default = componentDemo;